import React from 'react';
import { Link } from 'react-router-dom';


const Condition = () => {

  return (
    <>
    <style>{`
        h6{
            color:#000 !important;
        }
        ul {
            list-style-type: disc; 
          }
         .list-header{
            font-weight:500;
         } 
        
      `}</style>
  {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
    <div className="registration-form pb-10">
      <div className="justify-content-center text-center mt-4"></div>
      <h2 className="or mt-4" style={{ fontWeight: 'bold' }}>
        Terms and Conditions
      </h2>
      <form className="input-form pb-5 pt-2">
        <p>
          By accessing or using our Services, you agree to comply with our Terms and Conditions, including but not limited to, the use of the Services for lawful purposes, respecting intellectual property rights, and indemnifying against any claims arising from your use of the Services. 
        </>
        <div style={{ textAlign: 'center' }}>
            <Link to="/registration" className="button-outline" style={{ textDecoration: 'none', fontSize: '16px', marginLeft: '3px'}}>
                OK
            </Link>
            </div>
      </form>
      
    </div>
    
  </div> */}

    <div className="p-5">
    <h6>Ngyelso App (Leave Management App) Privacy PolicyVersion 1.0.0</h6>
    <h6>Effective Date: 18/03/2024</h6>
    <p>DK Limited operates the Ngyelso App which is a Leave Management App. This Privacy Policy outlines the types of information we may collect from users of the App, how we may use that information, and with whom we may share it. By using the App, you agree to the collection and use of information in accordance with this Privacy Policy. </p>
    <h6>Information We Collect</h6>
    <ul>
        <li><span className="list-header">Personal Information: </span>When you use the web interface of the App, we may collect personal information such as your name, employee ID, department, and other relevant details required for leave management purposes. </li>
        <li><span className="list-header">Internal Communication: </span>We may use your contact information to communicate with you about leave-related matters, including leave approvals, updates on leave balances, and other relevant notifications.  </li>
        <li><span className="list-header">Usage Information: </span>We may collect information about how you use the App, such as the features you access, the actions you take, and the frequency and duration of your activities. This information is used solely for improving the functionality and user experience of the App.</li>
    </ul> 
    <h6>How We Use Information</h6>
    <ul>
        <li><span className='list-header'>To Facilitate Leave Management: </span>We use the information we collect to facilitate the leave management process within our organization, including processing leave requests, maintaining accurate records, and ensuring compliance with internal policies and regulations.</li>
        <li><span className='list-header'>Internal Communication: </span>We may use your contact information to communicate with you about leave-related matters, including leave approvals, updates on leave balances, and other relevant notifications.  </li>
        <li><span className='list-header'>Analytics: </span>We may use usage information and analytics tools to analyze trends, monitor the performance of the App, and gather insights to improve its functionality and effectiveness for internal use. </li>
        <li><span className='list-header'>Legal Compliance: </span>We may use your information to comply with internal policies, regulations, and legal obligations related to leave management and employee data.</li>
        <li><span className='list-header'>Information Displayed in the App: </span>The App serves as a front-end user interface and only displays limited information such as the employee's name and leave-related details fetched from our servers. No personal information is stored or processed within the App itself.</li>
        <li><span className='list-header'>Information Sharing: </span>We do not disclose or share your personal information collected through the App with third parties, except in cases where disclosure is necessary for internal administrative purposes or as required by law.</li>
        <li><span className='list-header'>Data Security: </span>We take appropriate measures to protect the security of your information, including implementing technical and organizational safeguards to prevent unauthorized access, disclosure, alteration, or destruction of data. </li>
        <li><span className='list-header'>Children's Privacy: </span>The App is intended for use by employees within our organization and is not directed to children under the age of 18. We do not knowingly collect personal information from children under 18 in the context of the App. </li>
    </ul>
    <h6>Data Retention</h6>
    <ul>
        <li><span className='list-header'>Personal Information: </span>We retain personal information collected via the web interface for as long as necessary to fulfill the purposes outlined in this Privacy Policy unless a longer retention period is required or permitted by law. </li>
        <li><span className='list-header'>Leave Management Data: </span>Leave management data is retained for a specific period determined by our organization's internal policies and applicable legal requirements. Once this retention period expires, we securely delete or anonymize the data. </li>

    </ul>
    <h6>Changes to this Privacy Policy</h6>
    <ul>
        <li><span className='list-header'></span>We reserve the right to update or change this Privacy Policy at any time. Any changes will be effective immediately upon posting the revised Privacy Policy on this page. We encourage you to review this Privacy Policy periodically for any changes. </li>
    </ul>
    <h6>Contact Us</h6>
    <ul>
        <li><span className='list-header'></span>If you have any questions or concerns about this Privacy Policy or our privacy practices, please contact us at hr@dk.bt</li>
        <li><span className='list-header'></span>By using this App, you acknowledge that you have read and understood this Privacy Policy and agree to be bound by its terms.</li>

    </ul>
    <div style={{ textAlign: 'center' }}>
            <Link to="/registration" className="button-outline" style={{ textDecoration: 'none', fontSize: '16px', marginLeft: '3px'}}>
                OK
            </Link>
            </div>
   
    </div>
    </>
  );
};

export default Condition;
